;(function (window) {

	var AdditionalRegistrationManager = (function(argument) {

		var methods = Object.create(null);
		var model = null;
		var error = false;
		var current_path = false;
		methods.callbacks = {};

		methods.setModel = function(model){
			this.model = model;
			this.checkModel();
			return this;
		};

		methods.getModel = function(){
			return this.model;
		};

		methods.checkModel = function(){
			var model_status = typeof this.model === 'function';
			!model_status && this.errorsSwitcher({ error: model_status , type: 'model'});
			return this;
		};

		methods.errorsSwitcher = function(args){
			if(!args.error){
				switch(args.type){
					case 'model':
						this.error = true;
						this.model = null;
						console.error('Model must be a function');
						break;
					case 'function_manager':
						this.error = true;
						console.log('Registration manager have no this method');
						break;
				}
			}
			return this;
		};

		methods.check = function(object){

			if(~object.paths.indexOf(object.path_name)){

				return true;
			}
			else {


				if(object.checker()){
					APP.setJStorage('backTo', window.location.hash);
					Backbone.history.navigate(object.redirect_to, {trigger: true});
					return false;
				}

				if(object.callback){
					return object.callback();
				}

				return true;
			}
		};

		methods.isUserRegisteredForGames = function(object){


			var sid = APP.getJStorage('session_id'),
				user_id = APP.getJStorage('user_id')
			;

			var obj = _.extend({}, object, {
				paths: ['registerForGame'],
				checker: this._userHasSupportedGames.bind(this),
				redirect_to: 'registration/for_game'
			});

			if(this._isUserNeedRestore()){

				obj = _.extend({}, object, {
					paths: ['registerRecover'],
					checker: this._isUserNeedRestore.bind(this),
					redirect_to: 'registration/recovered'
				});

			}

			if(sid && CONFIG.OFF_SEASON){

				obj = _.extend({}, object, {
					paths: ['index'],
					checker: APP.vent.trigger('user:logout'),
					redirect_to:  CONFIG.OFF_SEASON ? 'off-season' : 'login'
				});
			}

			if (sid && !user_id && window.Cookies && window.Cookies.get('sid')) {
				return true;
			}

			return this.check(obj);
		};

		methods.isUserRestored = function(object){
			var obj = _.extend({}, object, {
				paths: ['registerRecover'],
				checker: this._isUserNeedRestore.bind(this),
				redirect_to: 'registration/recovered'
			});

			return obj;
		};

		methods._isUserNeedRestore = function(){
			var user = APP.module('instance').user;

			return !Boolean(user.get('recovered'));
		};

		methods._userHasSupportedGames = function(){

			var
				user = APP.module('instance').user,
				registration_object =  new this.model().toJSON(),
				supported_games = registration_object.games_supported;
			return supported_games.length &&
					!_.intersection(user.get('playing_games'), supported_games).length
					// !Boolean(~user.get('playing_games').indexOf(supported_games[0]))
				;
		};



		return methods

	}());

	window.AdditionalRegistrationManager = AdditionalRegistrationManager;

}(window));